import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { providersCasino } from 'config/config'; // Importing providersCasino configuration
import { gamesCasino } from 'config/config'; // Importing gamesCasino configuration

/**
 * Class representing the FilterCasinoReportView.
 * @extends JetView
 */
export default class FilterCasinoReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section configuration
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                },
            ],
        };

        const center_left = {
            // Center left section configuration
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'combo', // Combo box for provider selection
                    name: 'ProviderId',
                    localId: 'provider:combo',
                    label: _('Proveedor'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: {
                        body: {
                            dataFeed: function (text) {
                                // Function to fetch provider data
                                var vthis = this;
                                if (text.length > 2) {
                                    // Trigger data fetch if input length is greater than 2
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                            '{"Filter":"' + text + '"}', // Sending filter data
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text); // Parsing response
                                                    if (!resp.HasError) {
                                                        // Check for errors in response
                                                        vthis.parse(resp.Data); // Parsing data into combo
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
            ],
        };

        const center_right = {
            // Center right section configuration
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'combo', // Combo box for product selection
                    name: 'ProductId',
                    label: _('Producto'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: {
                        body: {
                            dataFeed: function (text) {
                                // Function to fetch product data
                                var vthis = this;
                                if (text.length > 2) {
                                    // Trigger data fetch if input length is greater than 2
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/GamesCasinoSelect',
                                            '{"Filter":"' + text + '"}', // Sending filter data
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text); // Parsing response
                                                    if (!resp.HasError) {
                                                        // Check for errors in response
                                                        vthis.parse(resp.Data); // Parsing data into combo
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
            ],
        };

        const right = {
            // Right section configuration (currently empty)
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        const upper_section = {
            // Upper section layout
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right], // Combining left, center left, and center right sections
                },
            ],
        };

        const buttons = {
            // Button section configuration
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Localized label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Localized label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('casinoReportLeague:filter', [
                            filterdata, // Triggering event with filter data
                        ]);
                    },
                },
            ],
        };

        return {
            // Returning the complete form configuration
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
